// setIsPrivateStreamUnlocked.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

/**
 * Set is private stream unlocked
 * @kind action
 * @param {string} {streamId} - stream id.
 * @param {boolean} {isPrivateStreamUnlocked} - is private stream unlocked or not.
 * @return {Promise} Action promise.
 */
const setIsPrivateStreamUnlocked =
  ({ streamId, isPrivateStreamUnlocked }) =>
  async dispatch => {
    return dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['liveStream', 'paid', streamId],
        data: {
          isPrivateStreamUnlocked: !!isPrivateStreamUnlocked,
        },
      },
    });
  };

export default setIsPrivateStreamUnlocked;
